import { render, staticRenderFns } from "./ProductCustomPriceView.vue?vue&type=template&id=232ab150"
import script from "./ProductCustomPriceView.vue?vue&type=script&lang=js"
export * from "./ProductCustomPriceView.vue?vue&type=script&lang=js"
import style0 from "./ProductCustomPriceView.vue?vue&type=style&index=0&id=232ab150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports